import mediumZoom from 'medium-zoom'
import './photoswipe.css'

export default class PhotoSwipe {
  init() {
    mediumZoom('.documentation-content img', { background: '#212530' })
  }
}
